import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {Modal, ModalHeader} from "reactstrap";
import {ViewInsightsForm} from "./ViewInsightsModal";
import { withTranslation } from 'react-i18next';

export class ViewInsightsButtonAndModalClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);

    }

    toggle(event) {
        event.preventDefault();
        this.setState({
            modal: !this.state.modal
        });
    }

    render() {
        const { t } = this.props;
        return [<button title={t('view_insights_button_and_modal.view_applicable_insights')} onClick={this.toggle} style={{marginRight:"1em"}}
                       className="dashboard-header-option">
            <FaIcon iconName="star"/>
            <p className="header-option-label">{t('view_insights_button_and_modal.insights')}</p>
        </button>,
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={`${this.props.className} custom-right-modal`}>
                <ModalHeader toggle={this.toggle}>{t('view_insights_button_and_modal.applicable_insights')}</ModalHeader>
                <ViewInsightsForm closeModal={this.toggle} onClientAdded={this.handleFormSubmitted}/>
            </Modal>
        ];

    }
}

export const ViewInsightsButtonAndModal = withTranslation()(ViewInsightsButtonAndModalClass);
export default ViewInsightsButtonAndModal;

